import React, { useEffect, useState } from "react";
import Modal from "react-modal";
import { useRecoilState, useRecoilValue } from "recoil";
import styled from "styled-components";
import ApiController from "../../controller/ApiController";
import { qrAuthState, qrAuthType } from "../../recoil/auth";
import { langState, langText } from "../../recoil/lang";
import "../../styles/CustomModal.css";

const GuideModal = (oProps: { isVisible: boolean; setVisible: any }) => {
  const [lang, setLang] = useRecoilState<number>(langState);
  const qrAuth = useRecoilValue<qrAuthType>(qrAuthState);
  const [pickupZone, setPickupZone] = useState<string>("");
  const [pickupZoneEn, setPickupZoneEn] = useState<string>("");
  const onCloseModal = () => {
    oProps.setVisible(false);
  };

  // API 호출
  const getStoreInfo = async () => {
    let res = await ApiController.store.storeInfo(qrAuth.user_id);

    if (res && res.data) {
      setPickupZone(res.data.pickup_name);
      setPickupZoneEn(res.data.pickup_name_en);
    }
  };

  useEffect(() => {
    if (oProps.isVisible) getStoreInfo();
  }, [oProps.isVisible]);

  return (
    <Modal
      isOpen={oProps.isVisible}
      onRequestClose={onCloseModal}
      className="guideModal modal-content bottom"
      closeTimeoutMS={100}
      ariaHideApp={false}
    >
      <Style>
        <div className="modal">
          <div className="modal_header">
            <img
              className="closeIcon"
              onClick={onCloseModal}
              src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_close.svg`}
              alt="ic"
            />
          </div>
          <div className="modal_content">
            <div className="row">
              <div className="circle">
                <h4>1</h4>
              </div>

              <h2>{langText.guideModal_title_one[lang]}</h2>
            </div>
            <h4 className="subtitle">
              {langText.guideModal_content_one[lang]}
            </h4>
            <div className="row">
              <div className="circle">
                <h4>2</h4>
              </div>
              <h2>{langText.guideModal_title_two[lang]}</h2>
            </div>
            <h4 className="subtitle">
              {langText.guideModal_content_two[lang]}
            </h4>
            <div className="row">
              <div className="circle">
                <h4>3</h4>
              </div>
              <h2>{langText.guideModal_title_three[lang]}</h2>
            </div>
            <h4 className="subtitle">
              {langText.guideModal_content_three[lang]}
            </h4>

            <h3 className="footer">{langText.guideModal_footer[lang]}</h3>
            <div className="pickupBadge">
              <h3>
                {`${langText.arrivalModal_pickup[lang]}: ${
                  lang === 0 ? pickupZone : pickupZoneEn
                }`}
              </h3>
            </div>
          </div>
          <button className="submitButton" onClick={onCloseModal}>
            {langText.guideModal_button_confirm[lang]}
          </button>
        </div>
      </Style>
    </Modal>
  );
};

export default GuideModal;

const Style = styled.div`
  .modal {
    padding: 25px 24px;
    position: relative;
  }

  .modal_header {
    width: 100%;
    display: flex;
    justify-content: center;
    padding-bottom: 7%;
    .closeIcon {
      position: absolute;
      right: 20px;
      top: 20px;
      width: 40px;
    }
  }

  .modal_content {
    width: 100%;
    padding: 0 14px;
    white-space: pre-line;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .row {
      padding-top: 12px;
      padding-bottom: 8px;
      display: flex;
      align-items: center;
      gap: 16px;
    }

    .subtitle {
      padding-bottom: 10px;
    }

    h2 {
      font-size: 28px;
      line-height: 32px;
      font-weight: 600;
      color: #ffffff;
      span {
        color: #ffffff;
        font-weight: 600;
        background: #40977f;
      }
    }

    h4 {
      padding-left: 5%;
      font-size: 18px;
      font-weight: 600;
      color: #ffffff;
      line-height: 24px;
    }
    h3 {
      padding: 6px 0 20px 0;
      font-size: 18px;
      line-height: 28px;
      font-weight: 400;
      color: #ffffff;
    }
    h3.footer {
      padding-top: 6%;
    }
  }

  .pickupBadge {
    display: inline-flex;
    justify-content: center;
    h3 {
      max-width: 90%;
      font-size: 18px;
      line-height: 22px;
      padding: 0;
      font-weight: 500;
      color: #ffffff;
      background: #ff4a4a;
      border-radius: 50px;
      padding: 6px 20px;
    }
  }

  .submitButton {
    position: relative;
    margin-top: 16px;
    width: 100%;
    padding: 18px 0;
    background: #4dd2ae;
    border-radius: 10px;
    color: #ffffff;
    font-size: 22px;
    line-height: 30px;
    font-weight: 600;
  }

  .circle {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 26px;
    height: 26px;
    border-radius: 100px;
    background: #4dd2ae;
    h4 {
      color: #343434;
      font-weight: 600;
    }
  }

  @media (max-width: 700px) {
    .modal {
      padding: 25px 14px;
      padding-top: 12%;
    }
    .modal_header {
      width: 100%;
      display: flex;
      justify-content: center;
      padding-bottom: 7%;
      .closeIcon {
        width: 32px;
        right: 12px;
        top: 12px;
      }
    }
    .modal_content {
      .row {
        padding: 6px 0;
        display: flex;
        align-items: flex-start;
        gap: 8px;
      }
      h2 {
        max-width: 90%;
        font-size: 18px;
        line-height: 20px;
      }
      h4 {
        padding-left: 24px;
        font-size: 12px;
        line-height: 16px;
        font-weight: 300;
      }
      h3 {
        padding: 6px 0 20px 0;
        font-size: 10px;
        line-height: 16px;
      }
      h3.footer {
        padding: 16px 0;
      }
    }

    .pickupBadge {
      h3 {
        font-size: 15px;
        line-height: 22px;
        padding: 4px 18px;
      }
    }

    .circle {
      width: 14px;
      height: 14px;
      margin-top: 3px;
      h4 {
        padding: 0;
        font-size: 12px;
        color: #343434;
        font-weight: 600;
      }
    }
    .submitButton {
      margin-top: 10px;
      padding: 12px 0;
      font-size: 20px;
      border-radius: 5px;
    }
  }
`;
